
import { useState } from 'react'
import { useRemoteCollection } from '../../api/hooks'
import { useCredentialTypes } from "./useCredentialTypes";
const useCredentialTypesCollection = (organizationId) => {
  const [credentialIDTypes, operations] = useRemoteCollection()
  const [initiallyLoaded, setInitiallyLoaded] = useState(false)
  const { syncCollection } = operations
  const { refetch } = useCredentialTypes((credentialTypes, organizationId) => {
    syncCollection(credentialTypes)
    setInitiallyLoaded(true)
  })

  return [
    {
      credentialIDTypes,
      initiallyLoaded
    },
    {
      refresh: refetch
    },
  ]
}

export default useCredentialTypesCollection